module.exports = __webpack_public_path__ + "static/img/2BtechnologicalassessmentCnfznb7PSY2KbxCouquwRafPig.d409222.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/originalframerhtml_files/2BtechnologicalassessmentCnfznb7PSY2KbxCouquwRafPig.jpg
// module id = vu8S
// module chunks = 62